// // // import React, { useState } from 'react';

// // // function VerifyrForm({setActiveForm}) {
// // //   const [formData, setFormData] = useState({
// // //     surname: '',
// // //     givennames: '',
// // //     idpassport: '',
// // //     certificatenumber: '',
// // //     notRobot: false
// // //   });
// // //   const[butonText,setButtonText]=useState('Verify');

// // //   const handleSubmit = (e) => {
// // //     e.preventDefault();
// // //     // Handle form submission logic here
// // //     console.log('Form submitted:', formData);
// // //   };

// // //     const handleInputChange = (e) => {
// // //     const { name, value, type, checked } = e.target;
// // //     setFormData(prev => ({
// // //       ...prev,
// // //       [name]: type === 'checkbox' ? checked : value
// // //     }));
// // //   };

// // //   const handleClear = () => {
// // //     setFormData({
// // //     surname: '',
// // //     givennames: '',
// // //     idpassport: '',
// // //     certificatenumber: '',
// // //       notRobot: false
// // //     });
// // //   };

// // //   const handleVerifyButton=()=>{
// // //     if(butonText == 'Verify'){
// // //       setButtonText("Submit");
// // //     }
// // //     else if(butonText == "Submit"){
// // //       setActiveForm("login");
// // //     }
// // //   }
// // //   return (
// // //     <>
// // //       <div className="max-716 w-100 rounded-1 border p-4">
// // //         <div className="font-24 font-700 mb-4 text-center text-primary-green  border-bottom pb-2">Please capture the seafarer details you want to verify</div>

// // //         <form onSubmit={handleSubmit} className='row g-3'>
// // //           <div className="col-12">
// // //             <div className="row align-items-center">
// // //               <div className="col-md-4">
// // //                 <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
// // //               </div>
// // //               <div className="col-md-8">
// // //                 <input
// // //                   type="text"
// // //                   className="form-control height-40 rounded-1 border-color-7D9199"
// // //                   name="surname"
// // //                   value={formData.surname}
// // //                   onChange={handleInputChange}
// // //                   required
// // //                 />
// // //               </div>
// // //             </div></div>
// // //           <div className="col-12"><div className="row align-items-center">
// // //             <div className="col-md-4">
// // //               <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
// // //             </div>
// // //             <div className="col-md-8">
// // //               <input
// // //                 type="text"
// // //                 className="form-control height-40 rounded-1 border-color-7D9199"
// // //                 name="fullName"
// // //                 value={formData.givennames}
// // //                   onChange={handleInputChange}
// // //                 required
// // //               />
// // //             </div>
// // //           </div></div>
// // //           <div className="col-12"><div className="row align-items-center">
// // //             <div className="col-md-4">
// // //               <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
// // //             </div>
// // //             <div className="col-md-8">
// // //               <input
// // //                 type="email"
// // //                 className="form-control height-40 rounded-1 border-color-7D9199"
// // //                 name="email"
// // //                 value={formData.idpassport}
// // //                 onChange={handleInputChange}
// // //                 required
// // //               />
// // //             </div>
// // //           </div></div>
// // //           <div className="col-12"><div className="row align-items-center">
// // //             <div className="col-md-4">
// // //               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate number</label>
// // //             </div>
// // //             <div className="col-md-8">
// // //               <input
// // //                 type="email"
// // //                 className="form-control height-40 rounded-1 border-color-7D9199"
// // //                 name="confirmEmail"
// // //                 value={formData.certificatenumber}
// // //                 onChange={handleInputChange}
// // //                 required
// // //               />
// // //             </div>
// // //           </div></div>

// // //           <div className="col-12"><div className="row align-items-center">
// // //             <div className="col-md-4">
// // //               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate number</label>
// // //             </div>
// // //             <div className="col-md-8">
// // //               <input
// // //                 type="text"
// // //                 className="form-control height-40 rounded-1 border-color-7D9199"
// // //                 name="organizationType"
// // //                 value={formData.organizationType}
// // //                 onChange={handleInputChange}
// // //                 required
// // //               />
// // //             </div>
// // //           </div></div>
// // //           <div className="col-12">
// // //             <div className="row align-items-center">
// // //               <div className="col-md-4"></div>
// // //               <div className="col-md-8">
// // //                 <div className="row">
// // //                   <div className="col-auto">
// // //                     <button
// // //                       type="submit"
// // //                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
// // //                       onClick={handleVerifyButton}
// // //                     >
// // //                       {butonText}
// // //                     </button>
// // //                   </div>
// // //                   <div className="col-auto">
// // //                     <button
// // //                       type="button"
// // //                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
// // //                       onClick={handleClear}
// // //                     >
// // //                       Clear
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               </div>
// // //             </div></div>



// // //         </form>
// // //       </div>
// // //     </>
// // //   )
// // // }

// // // export default VerifyrForm;

// // import React, { useState } from 'react';
// // import { WebApiURL } from '../Constants/Constants';

// // function VerifyForm({ setActiveForm }) {
// //   const [formData, setFormData] = useState({
// //     surname: '',
// //     givennames: '',
// //     idNumber: '',
// //     certificatenumber: '',
// //     organizationType: '',
// //     notRobot: false
// //   });

// //   const [buttonText, setButtonText] = useState('Verify');
// //   const [statusMessage, setStatusMessage] = useState('');
// //   const [results, setResults] = useState([]);
// //   const [isSubmitting, setIsSubmitting] = useState(false);

// //   const handleInputChange = (e) => {
// //     const { name, value, type, checked } = e.target;
// //     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
// //   };

// //   const handleClear = () => {
// //     setFormData({
// //       surname: '',
// //       givennames: '',
// //       idNumber: '',
// //       certificatenumber: '',
// //       organizationType: '',
// //       notRobot: false
// //     });
// //     setResults([]);
// //     setStatusMessage('');
// //     setButtonText('Verify');
// //   };

// //   const handleVerifyButton = () => {
// //     if (buttonText === 'Verify') setButtonText('Submit');
// //     else setActiveForm('login');
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setStatusMessage('');
// //     setResults([]);
// //     setIsSubmitting(true);

// //     try {
// //       const response = await fetch(`${WebApiURL}Verification/verify`, {
// //         method: 'POST',
// //         headers: { 'Content-Type': 'application/json' },
// //         body: JSON.stringify({
// //           CertificateNumber: formData.certificatenumber,
// //           IdNumber: formData.idNumber
// //         })
// //       });

// //       const text = await response.text();
// //       const data = text ? JSON.parse(text) : {};

// //       if (response.ok && data.matchedRecords?.length > 0) {
// //         setResults(data.matchedRecords);
// //       } else {
// //         setStatusMessage(data.message || 'No matching records found.');
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setStatusMessage('Server error or network issue.');
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// //     <div className="max-716 w-100 rounded-1 border p-4">
// //       <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
// //         Please capture the seafarer details you want to verify
// //       </div>

// //       {statusMessage && (
// //         <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
// //           {statusMessage}
// //         </div>
// //       )}

// //       <form onSubmit={handleSubmit} className="row g-3">
// //         {/* Surname */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="surname"
// //                 value={formData.surname}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Given Names */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="givennames"
// //                 value={formData.givennames}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* ID/Passport */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="idNumber"
// //                 value={formData.idNumber}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Certificate Number */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="certificatenumber"
// //                 value={formData.certificatenumber}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Organization Type */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4">
// //               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
// //             </div>
// //             <div className="col-md-8">
// //               <input
// //                 type="text"
// //                 className="form-control height-40 rounded-1 border-color-7D9199"
// //                 name="organizationType"
// //                 value={formData.organizationType}
// //                 onChange={handleInputChange}
// //                 required
// //               />
// //             </div>
// //           </div>
// //         </div>

// //         {/* Buttons */}
// //         <div className="col-12">
// //           <div className="row align-items-center">
// //             <div className="col-md-4"></div>
// //             <div className="col-md-8">
// //               <div className="row">
// //                 <div className="col-auto">
// //                   <button
// //                     type="submit"
// //                     className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
// //                     onClick={handleVerifyButton}
// //                     disabled={isSubmitting}
// //                   >
// //                     {isSubmitting ? 'Verifying...' : buttonText}
// //                   </button>
// //                 </div>
// //                 <div className="col-auto">
// //                   <button
// //                     type="button"
// //                     className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
// //                     onClick={handleClear}
// //                   >
// //                     Clear
// //                   </button>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       </form>

// //       {/* Display Results */}
// //       {results.length > 0 && (
// //         <table className="table table-bordered mt-4">
// //           <thead>
// //             <tr>
// //               <th>Num</th>
// //               <th>Surname</th>
// //               <th>Given Name</th>
// //               <th>Certificate Number</th>
// //               <th>Certificate Title</th>
// //               <th>Date Issued</th>
// //               <th>View</th>
// //             </tr>
// //           </thead>
// //           <tbody>
// //             {results.map((rec, index) => (
// //               <tr key={index}>
// //                 <td>{index + 1}</td>
// //                 <td>{rec.surname || '-'}</td>
// //                 <td>{rec.givenName || ''} {rec.middleName || ''}</td>
// //                 <td>{rec.certificateNumber}</td>
// //                 <td>{rec.certificateTitle}</td>
// //                 <td>{rec.issueDate || '-'}</td>
// //                 <td>
// //                   <a href="#" onClick={() => alert(JSON.stringify(rec, null, 2))}>
// //                     View Details
// //                   </a>
// //                 </td>
// //               </tr>
// //             ))}
// //           </tbody>
// //         </table>
// //       )}
// //     </div>
// //   );
// // }

// // export default VerifyForm;

// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';

// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//      certificateNumber: "",
//     idNumber: "",
//     passportNumber: "",
//     caseStatus: "",
//     certificateType: "",
//     expiryDate: "",
//     givenName: "",
//     middleName: "",
//     surname: "",
//     dateOfBirth: "",
//     nationality: "",
//     placeOfBirth: "",
//     stcwReference: "",
//     stcwRegulation: "",
//     certificateTitle: "",
//     certificateDepartment: "",
//     certificateGroup: "",
//     issueDate: "",
//     certificateExpiryDate: "",
//     issueCertDatePerformed: "",
//     interimExpiryDate: "",
//     stcwIssuePlace: "",
//     stcwPlaceOfExam: "",
//     placeOfExam: "",
//     trainingInstitution: "",
//     countryOfIssue: "",
//     issuingAuthority: "",
//     stcwCapacityOne: "",
//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens

//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//         certificateNumber: "",
//     idNumber: "",
//     passportNumber: "",
//     caseStatus: "",
//     certificateType: "",
//     expiryDate: "",
//     givenName: "",
//     middleName: "",
//     surname: "",
//     dateOfBirth: "",
//     nationality: "",
//     placeOfBirth: "",
//     stcwReference: "",
//     stcwRegulation: "",
//     certificateTitle: "",
//     certificateDepartment: "",
//     certificateGroup: "",
//     issueDate: "",
//     certificateExpiryDate: "",
//     issueCertDatePerformed: "",
//     interimExpiryDate: "",
//     stcwIssuePlace: "",
//     stcwPlaceOfExam: "",
//     placeOfExam: "",
//     trainingInstitution: "",
//     countryOfIssue: "",
//     issuingAuthority: "",
//     stcwCapacityOne: "",
//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');
//     else setActiveForm('login');
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setResults([]);
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}Verification/verify`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           CertificateNumber: formData.certificatenumber,
//           IdNumber: formData.idNumber
//         })
//       });

//       const text = await response.text();
//       const data = text ? JSON.parse(text) : {};

//       if (response.ok && data.matchedRecords?.length > 0) {
//         setResults(data.matchedRecords);
//       } else {
//         setStatusMessage(data.message || 'No matching records found.');
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ---------- dummy data you provided (used as fallbacks) ----------


//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

//   const mapToCertificateView = (recInput) => {
//     // merge API record over dummy (so API values win; dummy fills gaps)
//     //const formData = { ...DUMMY, ...(recInput || {}) };

//     const firstName = clean(formData.givenName) || clean(formData.firstName);
//     const surname = clean(formData.surname);
//     const fullName = [firstName, surname].filter(Boolean).join(' ');

//     // capacity rows (1..4)
//     const capacityDetailsRaw = [
//       { capacity: clean(formData.stcwCapacityOne),  limitation: clean(formData.stcwCapacityLimitationOn) },
//       { capacity: clean(formData.stcwCapacityTwo),  limitation: clean(formData.stcwCapacityLimitationTw) },
//       { capacity: clean(formData.stcwCapacityThree),limitation: clean(formData.stcwCapacityLimitationTh) },
//       { capacity: clean(formData.stcwCapacityFour), limitation: clean(formData.stcwCapacityLimitationFo) },
//     ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

//     // top function rows (1..4)
//     const functionsTopRaw = [
//       { func: clean(formData.stcwFunctionOne),   level: clean(formData.stcwLevelOne),   limitation: clean(formData.stcwFunctionLimitationOn) },
//       { func: clean(formData.stcwFunctionTwo),   level: clean(formData.stcwLevelTwo),   limitation: clean(formData.stcwFunctionLimitationTw) },
//       { func: clean(formData.stcwFunctionThree), level: clean(formData.stcwLevelThree), limitation: clean(formData.stcwFunctionLimitationTh) },
//       { func: clean(formData.stcwFunctionFour),  level: clean(formData.stcwLevelFour),  limitation: clean(formData.stcwFunctionLimitationFo) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     // bottom function rows (5..6)
//     const functionsBottomRaw = [
//       { func: clean(formData.stcwFunctionFive), level: clean(formData.stcwLevelFive), limitation: clean(formData.stcwFunctionLimitationFi) },
//       { func: clean(formData.stcwFunctionSix),  level: clean(formData.stcwLevelSix),  limitation: clean(formData.stcwFunctionLimitationSi) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     // endorsements (1..6)
//     const endorsements = [
//       formData.additionalEndorse1, formData.additionalEndorse2, formData.additionalEndorse3,
//       formData.additionalEndorse4, formData.additionalEndorse5, formData.additionalEndorse6
//     ].map(clean).filter(isPresent);

//     return {
//       salutationName: 'Recipient',
//       fullName: fullName || 'Seafarer Full Name',
//       firstName: firstName || '—',
//       surname: surname || '—',
//       dob: clean(formData.dateOfBirth) || '—',
//       nationality: clean(formData.nationality) || '—',
//       certificateNumber: clean(formData.certificateNumber) || '—',
//       stcwReference: clean(formData.stcwReference) || clean(formData.stcwRegulation) || '—',
//       issueDate: clean(formData.issueDate) || clean(formData.issueCertDatePerformed) || '—',
//       expiryDate: clean(formData.certificateExpiryDate) || clean(formData.expiryDate) || '—',
//       capacityDetails: capacityDetailsRaw,
//       functionsTop: functionsTopRaw,
//       functionsBottom: functionsBottomRaw,
//       endorsements
//     };
//   };

//   const openDetails = (rec) => {
//     const mapped = mapToCertificateView(rec);
//     setDetails(mapped);
//   };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div className="max-716 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//         Please capture the seafarer details you want to verify
//       </div>

//       {statusMessage && (
//         <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="row g-3">
//         {/* Surname */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="surname"
//                 value={formData.surname}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Given Names */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="givennames"
//                 value={formData.givennames}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* ID/Passport */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="idNumber"
//                 value={formData.idNumber}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Certificate Number */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="certificatenumber"
//                 value={formData.certificatenumber}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Organization Type */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="organizationType"
//                 value={formData.organizationType}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4"></div>
//             <div className="col-md-8">
//               <div className="row">
//                 <div className="col-auto">
//                   <button
//                     type="submit"
//                     className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                     onClick={handleVerifyButton}
//                     disabled={isSubmitting}
//                   >
//                     {isSubmitting ? 'Verifying...' : buttonText}
//                   </button>
//                 </div>
//                 <div className="col-auto">
//                   <button
//                     type="button"
//                     className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Display Results */}
//         {results.length > 0 && (
//           <table className="table table-bordered mt-4">
//             <thead>
//               <tr>
//                 <th>Num</th>
//                 <th>Surname</th>
//                 <th>Given Name</th>
//                 <th>Certificate Number</th>
//                 <th>Certificate Title</th>
//                 <th>Date Issued</th>
//                 <th>View</th>
//               </tr>
//             </thead>
//             <tbody>
//               {results.map((rec, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{rec.surname || '-'}</td>
//                   <td>{rec.givenName || ''} {rec.middleName || ''}</td>
//                   <td>{rec.certificateNumber}</td>
//                   <td>{rec.certificateTitle}</td>
//                   <td>{rec.issueDate || '-'}</td>
//                   <td>
//                     <a
//                       href="#"
//                       onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                     >
//                       View Details
//                     </a>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </form>

//       {/* ----- Certificate Modal (React version of your HTML) ----- */}
//       {details && (
//         <div
//           role="dialog"
//           aria-modal="true"
//           onClick={closeDetails}
//           style={{
//             position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//           }}
//         >
//           {/* stop click bubbling to close */}
//           <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//             <style>{`
//               :root {
//                 --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//               }
//               .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
//                 box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//               .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//               .cert-header p { margin:0; color:var(--muted); }
//               .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//               .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//               .kv .key { color: var(--muted); }
//               .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//               h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//               table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//               th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//               th { background:#f9fafb; font-weight:600; }
//               .muted { color: var(--muted); }
//               .actions { display:flex; gap:10px; margin-top:18px; }
//               .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//               .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//               .back-link { cursor:default; }
//               @media print {
//                 body { background:#fff; }
//                 #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                 .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                 .actions, .back-link { display:none !important; }
//                 a { color:inherit; text-decoration:none; }
//               }
//             `}</style>

//             <div id="cert-overlay" className="cert-page">
//               <header className="cert-header">
//                 <div className="muted">Dear <span>{details.salutationName}</span></div>
//                 <h1>
//                   Thank you for enquiring on the validity of the certificate for{' '}
//                   <span>{details.fullName}</span>
//                 </h1>
//               </header>

//               <section aria-labelledby="personal-details">
//                 <div className="grid-2">
//                   <div className="kv"><div className="key">Seafarer's Name</div><div>{details.firstName || '—'}</div></div>
//                   <div className="kv"><div className="key">Seafarer's Surname</div><div>{details.surname || '—'}</div></div>
//                   <div className="kv"><div className="key">Date of birth</div><div>{details.dob || '—'}</div></div>
//                   <div className="kv"><div className="key">Nationality</div><div>{details.nationality || '—'}</div></div>
//                   <div className="kv"><div className="key">Certificate Number</div><div>{details.certificateNumber || '—'}</div></div>
//                   <div className="kv"><div className="key">STCW Reference</div><div>{details.stcwReference || '—'}</div></div>
//                   <div className="kv"><div className="key">Issue/Revalidation Date</div><div>{details.issueDate || '—'}</div></div>
//                   <div className="kv"><div className="key">Date Of Expiry</div><div>{details.expiryDate || '—'}</div></div>
//                 </div>
//               </section>

//               <div className="divider" />

//               <section aria-labelledby="capacity-details">
//                 <h2 id="capacity-details">Capacity Details</h2>
//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Capacity</th>
//                       <th>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.capacity || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>
//               </section>

//               <section aria-labelledby="endorsements">
//                 <h2 id="endorsements">Additional Endorsement(s)</h2>
//                 <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                   {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                     <li key={i}>{e}</li>
//                   )) : null}
//                 </ul>
//               </section>

//               <div className="actions">
//                 <button className="btnx primary" onClick={() => window.print()}>Generate PDF</button>
//                 <button className="btnx" onClick={closeDetails}>Back</button>
//               </div>

//               <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                 <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//               </footer>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VerifyForm;



// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//     certificateNumber: "",
//     idNumber: "",
//     passportNumber: "",
//     caseStatus: "",
//     certificateType: "",
//     expiryDate: "",
//     givenName: "",
//     middleName: "",
//     surname: "",
//     DateOfBirth: "",
//     nationality: "",
//     placeOfBirth: "",
//     stcwReference: "",
//     stcwRegulation: "",
//     certificateTitle: "",
//     certificateDepartment: "",
//     certificateGroup: "",
//     issueDate: "",
//     certificateExpiryDate: "",
//     issueCertDatePerformed: "",
//     interimExpiryDate: "",
//     stcwIssuePlace: "",
//     stcwPlaceOfExam: "",
//     placeOfExam: "",
//     trainingInstitution: "",
//     countryOfIssue: "",
//     issuingAuthority: "",
//     stcwCapacityOne: "",
//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens

//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//       certificateNumber: "",
//       idNumber: "",
//       passportNumber: "",
//       caseStatus: "",
//       certificateType: "",
//       expiryDate: "",
//       // givenName: "",
//       middleName: "",
//       //surname: "",
//       DateOfBirth: "",
//       nationality: "",
//       placeOfBirth: "",
//       stcwReference: "",
//       stcwRegulation: "",
//       certificateTitle: "",
//       certificateDepartment: "",
//       certificateGroup: "",
//       issueDate: "",
//       certificateExpiryDate: "",
//       issueCertDatePerformed: "",
//       interimExpiryDate: "",
//       stcwIssuePlace: "",
//       stcwPlaceOfExam: "",
//       placeOfExam: "",
//       trainingInstitution: "",
//       countryOfIssue: "",
//       issuingAuthority: "",
//       stcwCapacityOne: "",
//       stcwCapacityTwo: "",
//       stcwCapacityThree: "",
//       stcwCapacityFour: "",
//       stcwCapacityLimitationOn: "",
//       stcwCapacityLimitationTw: "",
//       stcwCapacityLimitationTh: "",
//       stcwCapacityLimitationFo: "",
//       stcwFunctionOne: "",
//       stcwFunctionTwo: "",
//       stcwFunctionThree: "",
//       stcwFunctionFour: "",
//       stcwFunctionFive: "",
//       stcwFunctionSix: "",
//       stcwLevelOne: "",
//       stcwLevelTwo: "",
//       stcwLevelThree: "",
//       stcwLevelFour: "",
//       stcwLevelFive: "",
//       stcwLevelSix: "",
//       stcwFunctionLimitationOn: "",
//       stcwFunctionLimitationTw: "",
//       stcwFunctionLimitationTh: "",
//       stcwFunctionLimitationFo: "",
//       stcwFunctionLimitationFi: "",
//       stcwFunctionLimitationSi: "",
//       additionalEndorse1: "",
//       additionalEndorse2: "",
//       additionalEndorse3: "",
//       additionalEndorse4: "",
//       additionalEndorse5: "",
//       additionalEndorse6: "",
//       copValidUntilOne: "",
//       copValidUntilTwo: "",
//       copValidUntilThree: "",
//       copValidUntilFour: "",
//       copValidUntilFive: "",
//       copValidUntilSix: "",
//       copValidUntilSeven: "",
//       copValidUntilEight: "",
//       copValidUntilNine: "",
//       copValidUntilTen: "",
//       copValidUntilEleven: "",
//       copValidUntilTwelve: "",
//       retainOldCertificateNumber: "",
//       countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');
//     else setActiveForm('login');
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setResults([]);
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}Verification/verify`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           CertificateNumber: formData.certificateNumber,
//           IdNumber: formData.idNumber
//         })
//       });

//       const text = await response.text();
//       const data = text ? JSON.parse(text) : {};

//       if (response.ok && data.matchedRecords?.length > 0) {
//         setResults(data.matchedRecords);
//       } else {
//         setStatusMessage(data.message || 'No matching records found.');
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ---------- dummy data you provided (used as fallbacks) ----------


//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

//   const mapToCertificateView = (recInput) => {

//     // Utility functions
//     const clean = (v) => (v ?? '').toString().trim();
//     const isPresent = (v) => clean(v) !== '';

//     // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
//     const capacityDetailsRaw = [
//       { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
//       { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
//       { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
//       { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
//     ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));


//     const functionsTopRaw = [
//       { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
//       { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
//       { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
//       { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));


//     const functionsBottomRaw = [
//       { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
//       { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const endorsements = [
//       recInput.additionalEndorse1,
//       recInput.additionalEndorse2,
//       recInput.additionalEndorse3,
//       recInput.additionalEndorse4,
//       recInput.additionalEndorse5,
//       recInput.additionalEndorse6,
//     ].map(clean).filter(isPresent);


//     return {
//       salutationName: 'Recipient',

//       firstName: clean(recInput.givenName) || '—',
//       surname: clean(recInput.surname) || '—',
//       dob: clean(recInput.dateOfBirth) || '—',
//       certificateNumber: clean(recInput.certificateNumber) || '—',
//       stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
//       issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
//       expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
//       certificateTitle: clean(recInput.certificateTitle) || '—',
//       // Optional arrays
//       capacityDetails: capacityDetailsRaw,
//       functionsTop: functionsTopRaw,
//       functionsBottom: functionsBottomRaw,
//       endorsements,
//     };
//   };

//   const openDetails = (rec) => {
//     const mapped = mapToCertificateView(rec);
//     setDetails(mapped);
//   };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div className="max-716 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//         Please capture the seafarer details you want to verify
//       </div>

//       {statusMessage && (
//         <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="row g-3">
//         {/* Surname */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control ..."
//                 name="surname"
//                 value={formData.surname}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Given Names */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control ..."
//                 name="givenName"
//                 value={formData.givenName}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* ID/Passport */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="idNumber"
//                 value={formData.idNumber}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Certificate Number */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="certificatenumber"
//                 value={formData.certificatenumber}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Organization Type */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="organizationType"
//                 //       value={formData.organizationType}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4"></div>
//             <div className="col-md-8">
//               <div className="row">
//                 <div className="col-auto">
//                   <button
//                     type="submit"
//                     className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                     onClick={handleVerifyButton}
//                     disabled={isSubmitting}
//                   >
//                     {isSubmitting ? 'Verifying...' : buttonText}
//                   </button>
//                 </div>
//                 <div className="col-auto">
//                   <button
//                     type="button"
//                     className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Display Results */}
//         {results.length > 0 && (
//           <table className="table table-bordered mt-4">
//             <thead>
//               <tr>
//                 <th>Num</th>
//                 <th>Surname</th>
//                 <th>Given Name</th>
//                 <th>Certificate Number</th>
//                 <th>Certificate Title</th>
//                 <th>Date Issued</th>
//                 <th>View</th>
//               </tr>
//             </thead>
//             <tbody>
//               {results.map((rec, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{rec.Surname || '-'}</td>
//                   <td>{rec.GivenName || ''} {rec.MiddleName || ''}</td>
//                   <td>{rec.certificateNumber}</td>
//                   <td>{rec.certificateTitle}</td>
//                   <td>{rec.issueDate || '-'}</td>
//                   <td>
//                     <a
//                       href="#"
//                       onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                     >
//                       View Details
//                     </a>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </form>

//       {/* ----- Certificate Modal (React version of your HTML) ----- */}
//       {details && (
//         <div
//           role="dialog"
//           aria-modal="true"
//           onClick={closeDetails}
//           style={{
//             position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//           }}
//         >
//           {/* stop click bubbling to close */}
//           <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//             <style>{`
//               :root {
//                 --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//               }
//               .cert-page { background:#fff; margin-top: 260px; border:1px solid var(--border); border-radius:14px; padding:24px;
//                 box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//               .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//               .cert-header p { margin:0; color:var(--muted); }
//               .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//               .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//               .kv .key { color: var(--muted); }
//               .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//               h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//               table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//               th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//               th { background:#f9fafb; font-weight:600; }
//               .muted { color: var(--muted); }
//               .actions { display:flex; gap:10px; margin-top:18px; }
//               .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//               .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//               .back-link { cursor:default; }
//               @media print {
//                 body { background:#fff; }
//                 #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                 .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                 .actions, .back-link { display:none !important; }
//                 a { color:inherit; text-decoration:none; }
//               }
//             `}</style>

//             <div id="cert-overlay" className="cert-page">
//               <header className="cert-header">
//                 <div className="muted">Dear <span>{details.salutationName}</span></div>
//                 <h1>
//                   Thank you for enquiring on the validity of the certificate for{' '}
//                   <span>{details.fullName}</span>
//                 </h1>
//               </header>

//               <section aria-labelledby="personal-details">
//                 <div className="grid-2">
//                   <div className="kv">
//                     <div className="key">Seafarer's Name</div>
//                     <div>{details.firstName || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">Seafarer's Surname</div>
//                     <div>{details.surname || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">Date of birth</div>
//                     <div>{details.dob || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">Certificate Number</div>
//                     <div>{details.certificateNumber || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">STCW Reference</div>
//                     <div>{details.stcwReference || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">Issue/Revalidation Date</div>
//                     <div>{details.issueDate || '—'}</div>
//                   </div>
//                   <div className="kv">
//                     <div className="key">Date Of Expiry</div>
//                     <div>{details.expiryDate || '—'}</div>
//                   </div>

//                 </div>
//               </section>

//               <div className="divider" />

//               <section aria-labelledby="capacity-details">
//                 <h2 id="capacity-details">Capacity Details</h2>
//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Capacity</th>
//                       <th>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.capacity || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>
//               </section>

//               <section aria-labelledby="endorsements">
//                 <h2 id="endorsements">Additional Endorsement(s)</h2>
//                 <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                   {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                     <li key={i}>{e}</li>
//                   )) : null}
//                 </ul>
//               </section>

//               <div className="actions">
//                 <button className="btnx primary" onClick={() => window.print()}>Generate PDF</button>
//                 <button className="btnx" onClick={closeDetails}>Back</button>
//               </div>

//               <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                 <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//               </footer>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default VerifyForm;

//New Code

// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';



// import { useRef } from "react";


// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//      certificateNumber: "",
//      idNumber: "",
//      passportNumber: "",
//      caseStatus: "",
//      certificateType: "",
//      expiryDate: "",
//      givenName: "",
//      middleName: "",
//      surname: "",
//      DateOfBirth: "",
//      nationality: "",
//      placeOfBirth: "",
//      stcwReference: "",
//      stcwRegulation: "",
//      certificateTitle: "",
//      certificateDepartment: "",
//      certificateGroup: "",
//      issueDate: "",
//      certificateExpiryDate: "",
//      issueCertDatePerformed: "",
//      interimExpiryDate: "",
//      stcwIssuePlace: "",
//      stcwPlaceOfExam: "",
//      placeOfExam: "",
//      trainingInstitution: "",
//      countryOfIssue: "",
//      issuingAuthority: "",
//      stcwCapacityOne: "",

//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//  const certRef = useRef();
//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens


//   //pdf generation 

//   const handleGeneratePDF = async () => {
//   if (!details) return;

//   try {
//     const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         CertificateNumber: details.certificateNumber,
//         IdNumber: details.idNumber,
//       }),
//     });

//     if (!response.ok) {
//       const errorText = await response.text();
//       throw new Error(errorText || 'Failed to generate PDF');
//     }

//     const blob = await response.blob(); // PDF file as blob
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.href = url;
//     a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//     window.URL.revokeObjectURL(url);
//   } catch (err) {
//     console.error(err);
//     alert('Error generating PDF: ' + err.message);
//   }
// };


//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//         certificateNumber: "",
//     idNumber: "",
//     passportNumber: "",
//     caseStatus: "",
//     certificateType: "",
//     expiryDate: "",
//     givenName: "",
//     middleName: "",
//     surname: "",
//     DateOfBirth: "",
//     nationality: "",
//     placeOfBirth: "",
//     stcwReference: "",
//     stcwRegulation: "",
//     certificateTitle: "",
//     certificateDepartment: "",
//     certificateGroup: "",
//     issueDate: "",
//     certificateExpiryDate: "",
//     issueCertDatePerformed: "",
//     interimExpiryDate: "",
//     stcwIssuePlace: "",
//     stcwPlaceOfExam: "",
//     placeOfExam: "",
//     trainingInstitution: "",
//     countryOfIssue: "",
//     issuingAuthority: "",
//     stcwCapacityOne: "",
//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');
//     else setActiveForm('login');
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setResults([]);
//     setIsSubmitting(true);

//     try {
//       const response = await fetch(`${WebApiURL}Verification/verify`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//   CertificateNumber: formData.certificateNumber,
//   IdNumber: formData.idNumber
// })
//       });

//       const text = await response.text();
//       const data = text ? JSON.parse(text) : {};

//       if (response.ok && data.matchedRecords?.length > 0) {
//         setResults(data.matchedRecords);
//       } else {
//         setStatusMessage(data.message || 'No matching records found.');
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // ---------- dummy data you provided (used as fallbacks) ----------


//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

// const mapToCertificateView = (recInput) => {

//   // Utility functions
//   const clean = (v) => (v ?? '').toString().trim();
//   const isPresent = (v) => clean(v) !== '';

//   // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
//   const capacityDetailsRaw = [
//   { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
//   { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
//   { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
//   { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
// ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));


//   const functionsTopRaw = [
//   { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
//   { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
//   { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
//   { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
// ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));


//  const functionsBottomRaw = [
//   { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
//   { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
// ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//  const endorsements = [
//   recInput.additionalEndorse1,
//   recInput.additionalEndorse2,
//   recInput.additionalEndorse3,
//   recInput.additionalEndorse4,
//   recInput.additionalEndorse5,
//   recInput.additionalEndorse6,
// ].map(clean).filter(isPresent);


//   return {
//     salutationName: 'Recipient',

//  firstName: clean(recInput.givenName) || '—',
// surname: clean(recInput.surname) || '—',
// dob: clean(recInput.dateOfBirth) || '—',
// certificateNumber: clean(recInput.certificateNumber) || '—',
// stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
// issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
// expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
// certificateTitle: clean(recInput.certificateTitle) || '—',
//   // Optional arrays
//   capacityDetails: capacityDetailsRaw,
//   functionsTop: functionsTopRaw,
//   functionsBottom: functionsBottomRaw,
//   endorsements,
//   };
// };

// const openDetails = (rec) => {
//   const mapped = mapToCertificateView(rec);
//   setDetails(mapped);
// };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div ref={certRef} id="cert-overlay" className="cert-page">

//     <div className="max-716 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//         Please capture the seafarer details you want to verify
//       </div>

//       {statusMessage && (
//         <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="row g-3">
//         {/* Surname */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//             </div>
//             <div className="col-md-8">
//           <input
//   type="text"
//   className="form-control ..."
//   name="surname"
//   value={formData.surname}
//   onChange={handleInputChange}
//   // required
// />
//             </div>
//           </div>
//         </div>

//         {/* Given Names */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//             </div>
//             <div className="col-md-8">
//        <input
//   type="text"
//   className="form-control ..."
//   name="givenName"
//   value={formData.givenName}
//   onChange={handleInputChange}
//   // required
// />
//             </div>
//           </div>
//         </div>

//         {/* ID/Passport */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="idNumber"
//                 value={formData.idNumber}
//                 onChange={handleInputChange}
//                 required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Certificate Number */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="certificatenumber"
//                 value={formData.certificatenumber}
//                 onChange={handleInputChange}
//                 // required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Organization Type */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4">
//               <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//             </div>
//             <div className="col-md-8">
//               <input
//                 type="text"
//                 className="form-control height-40 rounded-1 border-color-7D9199"
//                 name="organizationType"
//          //       value={formData.organizationType}
//                 onChange={handleInputChange}
//                 // required
//               />
//             </div>
//           </div>
//         </div>

//         {/* Buttons */}
//         <div className="col-12">
//           <div className="row align-items-center">
//             <div className="col-md-4"></div>
//             <div className="col-md-8">
//               <div className="row">
//                 <div className="col-auto">
//                   <button
//                     type="submit"
//                     className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                     onClick={handleVerifyButton}
//                     disabled={isSubmitting}
//                   >
//                     {isSubmitting ? 'Verifying...' : buttonText}
//                   </button>
//                 </div>
//                 <div className="col-auto">
//                   <button
//                     type="button"
//                     className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                     onClick={handleClear}
//                   >
//                     Clear
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Display Results */}
//         {results.length > 0 && (
//           <table className="table table-bordered mt-4">
//             <thead>
//               <tr>
//                 <th>Num</th>
//                 <th>Surname</th>
//                 <th>Given Name</th>
//                 <th>Certificate Number</th>
//                 <th>Certificate Title</th>
//                 <th>Date Issued</th>
//                 <th>View</th>
//               </tr>
//             </thead>
//             <tbody>
//               {results.map((rec, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                  <td>{rec.Surname || '-'}</td>
// <td>{rec.GivenName || ''} {rec.MiddleName || ''}</td>
//                   <td>{rec.certificateNumber}</td>
//                   <td>{rec.certificateTitle}</td>
//                   <td>{rec.issueDate || '-'}</td>
//                   <td>
//                     <a
//                       href="#"
//                       onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                     >
//                       View Details
//                     </a>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         )}
//       </form>

//       {/* ----- Certificate Modal (React version of your HTML) ----- */}
//       {details && (
//         <div
//           role="dialog"
//           aria-modal="true"
//           onClick={closeDetails}
//           style={{
//             position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//           }}
//         >
//           {/* stop click bubbling to close */}
//           <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//             <style>{`
//               :root {
//                 --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//               }
//               .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
//                 box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//               .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//               .cert-header p { margin:0; color:var(--muted); }
//               .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//               .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//               .kv .key { color: var(--muted); }
//               .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//               h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//               table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//               th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//               th { background:#f9fafb; font-weight:600; }
//               .muted { color: var(--muted); }
//               .actions { display:flex; gap:10px; margin-top:18px; }
//               .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//               .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//               .back-link { cursor:default; }
//               @media print {
//                 body { background:#fff; }
//                 #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                 .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                 .actions, .back-link { display:none !important; }
//                 a { color:inherit; text-decoration:none; }
//               }
//             `}</style>

//             <div id="cert-overlay" className="cert-page">
//               <header className="cert-header">
//                 <div className="muted">Dear <span>{details.salutationName}</span></div>
//                 <h1>
//                   Thank you for enquiring on the validity of the certificate for{' '}
//                   <span>{details.fullName}</span>
//                 </h1>
//               </header>

//               <section aria-labelledby="personal-details">
// <div className="grid-2">
//   <div className="kv">
//   <div className="key">Seafarer's Name</div>
//   <div>{details.firstName || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">Seafarer's Surname</div>
//   <div>{details.surname || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">Date of birth</div>
//   <div>{details.dob || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">Certificate Number</div>
//   <div>{details.certificateNumber || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">STCW Reference</div>
//   <div>{details.stcwReference || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">Issue/Revalidation Date</div>
//   <div>{details.issueDate || '—'}</div>
// </div>
// <div className="kv">
//   <div className="key">Date Of Expiry</div>
//   <div>{details.expiryDate || '—'}</div>
// </div>

// </div>
//               </section>

//               <div className="divider" />

//               <section aria-labelledby="capacity-details">
//                 <h2 id="capacity-details">Capacity Details</h2>
//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Capacity</th>
//                       <th>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.capacity || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>

//                 <table>
//                   <thead>
//                     <tr>
//                       <th style={{ width: 64 }}>#</th>
//                       <th>Function</th>
//                       <th style={{ width: 180 }}>Level</th>
//                       <th style={{ width: 220 }}>Limitation</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                       <tr key={i}>
//                         <td>{i + 1}</td>
//                         <td>{row.func || '—'}</td>
//                         <td>{row.level || '—'}</td>
//                         <td>{row.limitation || '—'}</td>
//                       </tr>
//                     )) : null}
//                   </tbody>
//                 </table>
//               </section>

//               <section aria-labelledby="endorsements">
//                 <h2 id="endorsements">Additional Endorsement(s)</h2>
//                 <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                   {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                     <li key={i}>{e}</li>
//                   )) : null}
//                 </ul>
//               </section>

//               <div className="actions">
//                 <button className="btnx primary" onClick={handleGeneratePDF}>Generate PDF</button>
//                 <button className="btnx" onClick={closeDetails}>Back</button>
//               </div>

//               <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                 <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//               </footer>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//     </div>
//   );
// }


// export default VerifyForm;

//New Code
// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';

// import { useRef } from "react";

// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//      certificateNumber: "",
//      idNumber: "",
//      passportNumber: "",
//      caseStatus: "",
//      certificateType: "",
//      expiryDate: "",
//      givenName: "",
//      middleName: "",
//      surname: "",
//      DateOfBirth: "",
//      nationality: "",
//      placeOfBirth: "",
//      stcwReference: "",
//      stcwRegulation: "",
//      certificateTitle: "",
//      certificateDepartment: "",
//      certificateGroup: "",
//      issueDate: "",
//      certificateExpiryDate: "",
//      issueCertDatePerformed: "",
//      interimExpiryDate: "",
//      stcwIssuePlace: "",
//      stcwPlaceOfExam: "",
//      placeOfExam: "",
//      trainingInstitution: "",
//      countryOfIssue: "",
//      issuingAuthority: "",
//      stcwCapacityOne: "",

//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const certRef = useRef();
//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens


//   //pdf generation 

//   const handleGeneratePDF = async () => {
//     if (!details) return;

//     try {
//       const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           CertificateNumber: details.certificateNumber,
//           IdNumber: details.idNumber,
//         }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || 'Failed to generate PDF');
//       }

//       const blob = await response.blob(); // PDF file as blob
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       console.error(err);
//       alert('Error generating PDF: ' + err.message);
//     }
//   };


//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//       certificateNumber: "",
//       idNumber: "",
//       passportNumber: "",
//       caseStatus: "",
//       certificateType: "",
//       expiryDate: "",
//       givenName: "",
//       middleName: "",
//       surname: "",
//       DateOfBirth: "",
//       nationality: "",
//       placeOfBirth: "",
//       stcwReference: "",
//       stcwRegulation: "",
//       certificateTitle: "",
//       certificateDepartment: "",
//       certificateGroup: "",
//       issueDate: "",
//       certificateExpiryDate: "",
//       issueCertDatePerformed: "",
//       interimExpiryDate: "",
//       stcwIssuePlace: "",
//       stcwPlaceOfExam: "",
//       placeOfExam: "",
//       trainingInstitution: "",
//       countryOfIssue: "",
//       issuingAuthority: "",
//       stcwCapacityOne: "",
//       stcwCapacityTwo: "",
//       stcwCapacityThree: "",
//       stcwCapacityFour: "",
//       stcwCapacityLimitationOn: "",
//       stcwCapacityLimitationTw: "",
//       stcwCapacityLimitationTh: "",
//       stcwCapacityLimitationFo: "",
//       stcwFunctionOne: "",
//       stcwFunctionTwo: "",
//       stcwFunctionThree: "",
//       stcwFunctionFour: "",
//       stcwFunctionFive: "",
//       stcwFunctionSix: "",
//       stcwLevelOne: "",
//       stcwLevelTwo: "",
//       stcwLevelThree: "",
//       stcwLevelFour: "",
//       stcwLevelFive: "",
//       stcwLevelSix: "",
//       stcwFunctionLimitationOn: "",
//       stcwFunctionLimitationTw: "",
//       stcwFunctionLimitationTh: "",
//       stcwFunctionLimitationFo: "",
//       stcwFunctionLimitationFi: "",
//       stcwFunctionLimitationSi: "",
//       additionalEndorse1: "",
//       additionalEndorse2: "",
//       additionalEndorse3: "",
//       additionalEndorse4: "",
//       additionalEndorse5: "",
//       additionalEndorse6: "",
//       copValidUntilOne: "",
//       copValidUntilTwo: "",
//       copValidUntilThree: "",
//       copValidUntilFour: "",
//       copValidUntilFive: "",
//       copValidUntilSix: "",
//       copValidUntilSeven: "",
//       copValidUntilEight: "",
//       copValidUntilNine: "",
//       copValidUntilTen: "",
//       copValidUntilEleven: "",
//       copValidUntilTwelve: "",
//       retainOldCertificateNumber: "",
//       countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');
//     else setActiveForm('login');
//   };

//  const handleSubmit = async (e) => {
//   e.preventDefault();
//   setStatusMessage('');
//   setResults([]);
//   setIsSubmitting(true);

//   const idFilled = (formData.idNumber || '').trim() !== '';
//   const certFilled = (formData.certificateNumber || '').trim() !== '';
//   if ((idFilled && certFilled) || (!idFilled && !certFilled)) {
//     setStatusMessage('Please enter either an ID Number OR a Certificate Number');
//     setIsSubmitting(false);
//     return;
//   }

//   try {
//     const response = await fetch(`${WebApiURL}Verification/verify`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         CertificateNumber: formData.certificateNumber,
//         IdNumber: formData.idNumber
//       })
//     });

//     const text = await response.text();
//     let data;

//     try {
//       data = JSON.parse(text);
//     } catch {
//       console.error("Non-JSON response from server:", text);
//       setStatusMessage("Server returned invalid response format.");
//       return;
//     }

//     if (response.ok && data.matchedRecords?.length > 0) {
//       setResults(data.matchedRecords);
//     } else {
//       setStatusMessage(data.message || 'No matching records found.');
//     }
//   } catch (err) {
//     console.error(err);
//     setStatusMessage('Server error or network issue.');
//   } finally {
//     setIsSubmitting(false);
//   }
// };

//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

//   const mapToCertificateView = (recInput) => {
//     // Utility functions
//     const clean = (v) => (v ?? '').toString().trim();
//     const isPresent = (v) => clean(v) !== '';

//     // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
//     const capacityDetailsRaw = [
//       { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
//       { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
//       { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
//       { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
//     ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

//     const functionsTopRaw = [
//       { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
//       { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
//       { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
//       { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const functionsBottomRaw = [
//       { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
//       { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const endorsements = [
//       recInput.additionalEndorse1,
//       recInput.additionalEndorse2,
//       recInput.additionalEndorse3,
//       recInput.additionalEndorse4,
//       recInput.additionalEndorse5,
//       recInput.additionalEndorse6,
//     ].map(clean).filter(isPresent);

//     return {
//       salutationName: 'Recipient',

//       firstName: clean(recInput.givenName) || '—',
//       surname: clean(recInput.surname) || '—',
//       dob: clean(recInput.dateOfBirth) || '—',
//       certificateNumber: clean(recInput.certificateNumber) || '—',
//       stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
//       issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
//       expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
//       certificateTitle: clean(recInput.certificateTitle) || '—',
//       // Optional arrays
//       capacityDetails: capacityDetailsRaw,
//       functionsTop: functionsTopRaw,
//       functionsBottom: functionsBottomRaw,
//       endorsements,
//     };
//   };

//   const openDetails = (rec) => {
//     const mapped = mapToCertificateView(rec);
//     setDetails(mapped);
//   };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div ref={certRef} id="cert-overlay" className="cert-page">

//       <div className="max-716 w-100 rounded-1 border p-4">
//         <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//           Please capture the seafarer details you want to verify
//         </div>

//         {statusMessage && (
//           <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//             {statusMessage}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="row g-3">
//           {/* Surname */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="surname"
//                   value={formData.surname}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Given Names */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="givenName"
//                   value={formData.givenName}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* ID/Passport */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="idNumber"
//                   value={formData.idNumber}
//                   onChange={handleInputChange}
//                   // removed required to allow either-or
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Certificate Number */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="certificateNumber"          
//                   value={formData.certificateNumber}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Organization Type */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="organizationType"
//                   // value={formData.organizationType}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4"></div>
//               <div className="col-md-8">
//                 <div className="row">
//                   <div className="col-auto">
//                     <button
//                       type="submit"
//                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                       onClick={handleVerifyButton}
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? 'Verifying...' : buttonText}
//                     </button>
//                   </div>
//                   <div className="col-auto">
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                       onClick={handleClear}
//                     >
//                       Clear
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Display Results */}
//           {results.length > 0 && (
//             <table className="table table-bordered mt-4">
//               <thead>
//                 <tr>
//                   <th>Num</th>
//                   <th>Surname</th>
//                   <th>Given Name</th>
//                   <th>Certificate Number</th>
//                   <th>Certificate Title</th>
//                   <th>Date Issued</th>
//                   <th>View</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {results.map((rec, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{rec.surname || '-'}</td>
//                     <td>{rec.givenName || ''} {rec.MiddleName || ''}</td>
//                     <td>{rec.certificateNumber}</td>
//                     <td>{rec.certificateTitle}</td>
//                     <td>{rec.issueDate || '-'}</td>
//                     <td>
//                       <a
//                         href="#"
//                         onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                       >
//                         View Details
//                       </a>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </form>

//         {/* ----- Certificate Modal (React version of your HTML) ----- */}
//         {details && (
//           <div
//             role="dialog"
//             aria-modal="true"
//             onClick={closeDetails}
//             style={{
//               position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//               display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//             }}
//           >
//             {/* stop click bubbling to close */}
//             <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//               <style>{`
//                 :root {
//                   --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//                 }
//                 .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
//                   box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//                 .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//                 .cert-header p { margin:0; color:var(--muted); }
//                 .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//                 .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//                 .kv .key { color: var(--muted); }
//                 .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//                 h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//                 table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//                 th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//                 th { background:#f9fafb; font-weight:600; }
//                 .muted { color: var(--muted); }
//                 .actions { display:flex; gap:10px; margin-top:18px; }
//                 .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//                 .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//                 .back-link { cursor:default; }
//                 @media print {
//                   body { background:#fff; }
//                   #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                   .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                   .actions, .back-link { display:none !important; }
//                   a { color:inherit; text-decoration:none; }
//                 }
//               `}</style>

//               <div id="cert-overlay" className="cert-page">
//                 <header className="cert-header">
//                   <div className="muted">Dear <span>{details.salutationName}</span></div>
//                   <h1>
//                     Thank you for enquiring on the validity of the certificate for{' '}
//                     <span>{details.fullName}</span>
//                   </h1>
//                 </header>

//                 <section aria-labelledby="personal-details">
//                   <div className="grid-2">
//                     <div className="kv">
//                       <div className="key">Seafarer's Name</div>
//                       <div>{details.firstName || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Seafarer's Surname</div>
//                       <div>{details.surname || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date of birth</div>
//                       <div>{details.dob || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Certificate Number</div>
//                       <div>{details.certificateNumber || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">STCW Reference</div>
//                       <div>{details.stcwReference || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Issue/Revalidation Date</div>
//                       <div>{details.issueDate || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date Of Expiry</div>
//                       <div>{details.expiryDate || '—'}</div>
//                     </div>

//                   </div>
//                 </section>

//                 <div className="divider" />

//                 <section aria-labelledby="capacity-details">
//                   <h2 id="capacity-details">Capacity Details</h2>
//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Capacity</th>
//                         <th>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.capacity || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>
//                 </section>

//                 <section aria-labelledby="endorsements">
//                   <h2 id="endorsements">Additional Endorsement(s)</h2>
//                   <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                     {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                       <li key={i}>{e}</li>
//                     )) : null}
//                   </ul>
//                 </section>

//                 <div className="actions">
//                   <button className="btnx primary" onClick={handleGeneratePDF}>Generate PDF</button>
//                   <button className="btnx" onClick={closeDetails}>Back</button>
//                 </div>

//                 <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                   <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//                 </footer>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default VerifyForm;


//New Code

// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';

// import { useRef } from "react";

// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//      certificateNumber: "",
//      idNumber: "",
//      passportNumber: "",
//      caseStatus: "",
//      certificateType: "",
//      expiryDate: "",
//      givenName: "",
//      middleName: "",
//      surname: "",
//      DateOfBirth: "",
//      nationality: "",
//      placeOfBirth: "",
//      stcwReference: "",
//      stcwRegulation: "",
//      certificateTitle: "",
//      certificateDepartment: "",
//      certificateGroup: "",
//      issueDate: "",
//      certificateExpiryDate: "",
//      issueCertDatePerformed: "",
//      interimExpiryDate: "",
//      stcwIssuePlace: "",
//      stcwPlaceOfExam: "",
//      placeOfExam: "",
//      trainingInstitution: "",
//      countryOfIssue: "",
//      issuingAuthority: "",
//      stcwCapacityOne: "",

//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const certRef = useRef();
//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens


//   //pdf generation 

//   const handleGeneratePDF = async () => {
//     if (!details) return;

//     try {
//       const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           CertificateNumber: details.certificateNumber,
//           IdNumber: details.idNumber,
//         }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || 'Failed to generate PDF');
//       }

//       const blob = await response.blob(); // PDF file as blob
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       console.error(err);
//       alert('Error generating PDF: ' + err.message);
//     }
//   };


//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//       certificateNumber: "",
//       idNumber: "",
//       passportNumber: "",
//       caseStatus: "",
//       certificateType: "",
//       expiryDate: "",
//       givenName: "",
//       middleName: "",
//       surname: "",
//       DateOfBirth: "",
//       nationality: "",
//       placeOfBirth: "",
//       stcwReference: "",
//       stcwRegulation: "",
//       certificateTitle: "",
//       certificateDepartment: "",
//       certificateGroup: "",
//       issueDate: "",
//       certificateExpiryDate: "",
//       issueCertDatePerformed: "",
//       interimExpiryDate: "",
//       stcwIssuePlace: "",
//       stcwPlaceOfExam: "",
//       placeOfExam: "",
//       trainingInstitution: "",
//       countryOfIssue: "",
//       issuingAuthority: "",
//       stcwCapacityOne: "",
//       stcwCapacityTwo: "",
//       stcwCapacityThree: "",
//       stcwCapacityFour: "",
//       stcwCapacityLimitationOn: "",
//       stcwCapacityLimitationTw: "",
//       stcwCapacityLimitationTh: "",
//       stcwCapacityLimitationFo: "",
//       stcwFunctionOne: "",
//       stcwFunctionTwo: "",
//       stcwFunctionThree: "",
//       stcwFunctionFour: "",
//       stcwFunctionFive: "",
//       stcwFunctionSix: "",
//       stcwLevelOne: "",
//       stcwLevelTwo: "",
//       stcwLevelThree: "",
//       stcwLevelFour: "",
//       stcwLevelFive: "",
//       stcwLevelSix: "",
//       stcwFunctionLimitationOn: "",
//       stcwFunctionLimitationTw: "",
//       stcwFunctionLimitationTh: "",
//       stcwFunctionLimitationFo: "",
//       stcwFunctionLimitationFi: "",
//       stcwFunctionLimitationSi: "",
//       additionalEndorse1: "",
//       additionalEndorse2: "",
//       additionalEndorse3: "",
//       additionalEndorse4: "",
//       additionalEndorse5: "",
//       additionalEndorse6: "",
//       copValidUntilOne: "",
//       copValidUntilTwo: "",
//       copValidUntilThree: "",
//       copValidUntilFour: "",
//       copValidUntilFive: "",
//       copValidUntilSix: "",
//       copValidUntilSeven: "",
//       copValidUntilEight: "",
//       copValidUntilNine: "",
//       copValidUntilTen: "",
//       copValidUntilEleven: "",
//       copValidUntilTwelve: "",
//       retainOldCertificateNumber: "",
//       countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');

//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setStatusMessage('');
//   setResults([]);
//   setIsSubmitting(true);

//   const idFilled = (formData.idNumber || '').trim() !== '';
//   const certFilled = (formData.certificateNumber || '').trim() !== '';

//   // Validation check
//   if (!idFilled && !certFilled) {
//     setStatusMessage('Please enter either an ID Number OR a Certificate Number.');
//     setIsSubmitting(false);
//     return;
//   }

//   // Build request body dynamically
//   const requestBody = {};
//   if (idFilled) requestBody.IdNumber = formData.idNumber;
//   if (certFilled) requestBody.CertificateNumber = formData.certificateNumber;

//   try {
//     const response = await fetch(`${WebApiURL}Verification/verify`, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(requestBody)
//     });

//     const text = await response.text();
//     let data;

//     try {
//       data = JSON.parse(text);
//     } catch {
//       setStatusMessage("Server returned invalid response format.");
//       return;
//     }

//     if (response.ok && data.matchedRecords?.length > 0) {
//       setResults(data.matchedRecords);
//       setStatusMessage('Verification successful.');

//       // Auto clear after 10 seconds
//       setTimeout(() => setStatusMessage(''), 10000);
//     } else {
//       setStatusMessage(data.message || 'No matching records found.');
//       setTimeout(() => setStatusMessage(''), 10000);
//     }
//   } catch (err) {
//     setStatusMessage('Server error or network issue.');
//   } finally {
//     setIsSubmitting(false);
//   }
// };



//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

//   const mapToCertificateView = (recInput) => {
//     // Utility functions
//     const clean = (v) => (v ?? '').toString().trim();
//     const isPresent = (v) => clean(v) !== '';

//     // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
//     const capacityDetailsRaw = [
//       { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
//       { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
//       { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
//       { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
//     ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

//     const functionsTopRaw = [
//       { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
//       { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
//       { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
//       { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const functionsBottomRaw = [
//       { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
//       { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const endorsements = [
//       recInput.additionalEndorse1,
//       recInput.additionalEndorse2,
//       recInput.additionalEndorse3,
//       recInput.additionalEndorse4,
//       recInput.additionalEndorse5,
//       recInput.additionalEndorse6,
//     ].map(clean).filter(isPresent);

//     return {
//       salutationName: 'Recipient',

//       firstName: clean(recInput.givenName) || '—',
//       surname: clean(recInput.surname) || '—',
//       dob: clean(recInput.dateOfBirth) || '—',
//       certificateNumber: clean(recInput.certificateNumber) || '—',
//       stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
//       issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
//       expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
//       certificateTitle: clean(recInput.certificateTitle) || '—',
//       // Optional arrays
//       capacityDetails: capacityDetailsRaw,
//       functionsTop: functionsTopRaw,
//       functionsBottom: functionsBottomRaw,
//       endorsements,
//     };
//   };

//   const openDetails = (rec) => {
//     const mapped = mapToCertificateView(rec);
//     setDetails(mapped);
//   };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div ref={certRef} id="cert-overlay" className="cert-page">

//       <div className="max-716 w-100 rounded-1 border p-4">
//         <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//           Please capture the seafarer details you want to verify
//         </div>

//         {statusMessage && (
//           <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//             {statusMessage}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="row g-3">
//           {/* Surname */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="surname"
//                   value={formData.surname}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Given Names */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="givenName"
//                   value={formData.givenName}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* ID/Passport */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="idNumber"
//                   value={formData.idNumber}
//                   onChange={handleInputChange}
//                   // removed required to allow either-or
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Certificate Number */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="certificateNumber"          
//                   value={formData.certificateNumber}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Organization Type */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="organizationType"
//                   // value={formData.organizationType}
//                   onChange={handleInputChange}
//                   // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4"></div>
//               <div className="col-md-8">
//                 <div className="row">
//                   <div className="col-auto">
//                     <button
//                       type="submit"
//                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                       onClick={handleVerifyButton}
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? 'Verifying...' : buttonText}
//                     </button>
//                   </div>
//                   <div className="col-auto">
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                       onClick={handleClear}
//                     >
//                       Clear
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Display Results */}
//           {results.length > 0 && (
//             <table className="table table-bordered mt-4">
//               <thead>
//                 <tr>
//                   <th>Num</th>
//                   <th>Surname</th>
//                   <th>Given Name</th>
//                   <th>Certificate Number</th>
//                   <th>Certificate Title</th>
//                   <th>Date Issued</th>
//                   <th>View</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {results.map((rec, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{rec.surname || '-'}</td>
//                     <td>{rec.givenName || ''} {rec.MiddleName || ''}</td>
//                     <td>{rec.certificateNumber}</td>
//                     <td>{rec.certificateTitle}</td>
//                     <td>{rec.issueDate || '-'}</td>
//                     <td>
//                       <a
//                         href="#"
//                         onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                       >
//                         View Details
//                       </a>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </form>

//         {/* ----- Certificate Modal (React version of your HTML) ----- */}
//         {details && (
//           <div
//             role="dialog"
//             aria-modal="true"
//             onClick={closeDetails}
//             style={{
//               position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//               display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//             }}
//           >
//             {/* stop click bubbling to close */}
//             <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//               <style>{`
//                 :root {
//                   --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//                 }
//                 .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
//                   box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//                 .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//                 .cert-header p { margin:0; color:var(--muted); }
//                 .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//                 .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//                 .kv .key { color: var(--muted); }
//                 .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//                 h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//                 table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//                 th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//                 th { background:#f9fafb; font-weight:600; }
//                 .muted { color: var(--muted); }
//                 .actions { display:flex; gap:10px; margin-top:18px; }
//                 .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//                 .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//                 .back-link { cursor:default; }
//                 @media print {
//                   body { background:#fff; }
//                   #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                   .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                   .actions, .back-link { display:none !important; }
//                   a { color:inherit; text-decoration:none; }
//                 }
//               `}</style>

//               <div id="cert-overlay" className="cert-page">
//                 <header className="cert-header">
//                   <div className="muted">Dear <span>{details.salutationName}</span></div>
//                   <h1>
//                     Thank you for enquiring on the validity of the certificate for{' '}
//                     <span>{details.fullName}</span>
//                   </h1>
//                 </header>

//                 <section aria-labelledby="personal-details">
//                   <div className="grid-2">
//                     <div className="kv">
//                       <div className="key">Seafarer's Name</div>
//                       <div>{details.firstName || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Seafarer's Surname</div>
//                       <div>{details.surname || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date of birth</div>
//                       <div>{details.dob || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Certificate Number</div>
//                       <div>{details.certificateNumber || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">STCW Reference</div>
//                       <div>{details.stcwReference || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Issue/Revalidation Date</div>
//                       <div>{details.issueDate || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date Of Expiry</div>
//                       <div>{details.expiryDate || '—'}</div>
//                     </div>

//                   </div>
//                 </section>

//                 <div className="divider" />

//                 <section aria-labelledby="capacity-details">
//                   <h2 id="capacity-details">Capacity Details</h2>
//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Capacity</th>
//                         <th>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.capacity || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>
//                 </section>

//                 <section aria-labelledby="endorsements">
//                   <h2 id="endorsements">Additional Endorsement(s)</h2>
//                   <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                     {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                       <li key={i}>{e}</li>
//                     )) : null}
//                   </ul>
//                 </section>

//                 <div className="actions">
//                   <button className="btnx primary" onClick={handleGeneratePDF}>Generate PDF</button>
//                   <button className="btnx" onClick={closeDetails}>Back</button>
//                 </div>

//                 <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                   <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//                 </footer>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default VerifyForm;

//17/10/2025

// import React, { useState } from 'react';
// import { WebApiURL } from '../Constants/Constants';

// import { useRef } from "react";

// function VerifyForm({ setActiveForm }) {
//   // ---------- your existing state ----------
//   const [formData, setFormData] = useState({
//     certificateNumber: "",
//     idNumber: "",
//     passportNumber: "",
//     caseStatus: "",
//     certificateType: "",
//     expiryDate: "",
//     givenName: "",
//     middleName: "",
//     surname: "",
//     DateOfBirth: "",
//     nationality: "",
//     placeOfBirth: "",
//     stcwReference: "",
//     stcwRegulation: "",
//     certificateTitle: "",
//     certificateDepartment: "",
//     certificateGroup: "",
//     issueDate: "",
//     certificateExpiryDate: "",
//     issueCertDatePerformed: "",
//     interimExpiryDate: "",
//     stcwIssuePlace: "",
//     stcwPlaceOfExam: "",
//     placeOfExam: "",
//     trainingInstitution: "",
//     countryOfIssue: "",
//     issuingAuthority: "",
//     stcwCapacityOne: "",

//     stcwCapacityTwo: "",
//     stcwCapacityThree: "",
//     stcwCapacityFour: "",
//     stcwCapacityLimitationOn: "",
//     stcwCapacityLimitationTw: "",
//     stcwCapacityLimitationTh: "",
//     stcwCapacityLimitationFo: "",
//     stcwFunctionOne: "",
//     stcwFunctionTwo: "",
//     stcwFunctionThree: "",
//     stcwFunctionFour: "",
//     stcwFunctionFive: "",
//     stcwFunctionSix: "",
//     stcwLevelOne: "",
//     stcwLevelTwo: "",
//     stcwLevelThree: "",
//     stcwLevelFour: "",
//     stcwLevelFive: "",
//     stcwLevelSix: "",
//     stcwFunctionLimitationOn: "",
//     stcwFunctionLimitationTw: "",
//     stcwFunctionLimitationTh: "",
//     stcwFunctionLimitationFo: "",
//     stcwFunctionLimitationFi: "",
//     stcwFunctionLimitationSi: "",
//     additionalEndorse1: "",
//     additionalEndorse2: "",
//     additionalEndorse3: "",
//     additionalEndorse4: "",
//     additionalEndorse5: "",
//     additionalEndorse6: "",
//     copValidUntilOne: "",
//     copValidUntilTwo: "",
//     copValidUntilThree: "",
//     copValidUntilFour: "",
//     copValidUntilFive: "",
//     copValidUntilSix: "",
//     copValidUntilSeven: "",
//     copValidUntilEight: "",
//     copValidUntilNine: "",
//     copValidUntilTen: "",
//     copValidUntilEleven: "",
//     copValidUntilTwelve: "",
//     retainOldCertificateNumber: "",
//     countryOfIssueRegI10: "",
//     notRobot: false
//   });

//   const [buttonText, setButtonText] = useState('Verify');
//   const [statusMessage, setStatusMessage] = useState('');
//   const [results, setResults] = useState([]);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const certRef = useRef();
//   // ---------- added: modal state ----------
//   const [details, setDetails] = useState(null); // when set, modal opens


//   //pdf generation 

//   const handleGeneratePDF = async () => {
//     if (!details) return;

//     // Get logged-in user from localStorage
//     const user = JSON.parse(localStorage.getItem("user") || "{}");

//     // ✅ Check for the actual property from OTP response
//     if (!user?.userId) {
//       alert("User not authenticated. Please verify OTP first.");
//       return;
//     }

//     // ---------- DEBUG: log user object ----------
//     console.log("User from localStorage:", user);
//     console.log("UserId being sent to API:", user.userId);

//     try {
//       const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           CertificateNumber: details.certificateNumber,
//           IdNumber: details.idNumber,
//           UserId: user.userId, // ✅ use correct property
//           FullName: user.fullName

//         }),
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(errorText || 'Failed to generate PDF');
//       }

//       const blob = await response.blob(); // PDF file as blob
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       window.URL.revokeObjectURL(url);
//     } catch (err) {
//       console.error(err);
//       alert('Error generating PDF: ' + err.message);
//     }
//   };


//   // ---------- your handlers (unchanged) ----------
//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
//   };

//   const handleClear = () => {
//     setFormData({
//       certificateNumber: "",
//       idNumber: "",
//       passportNumber: "",
//       caseStatus: "",
//       certificateType: "",
//       expiryDate: "",
//       givenName: "",
//       middleName: "",
//       surname: "",
//       DateOfBirth: "",
//       nationality: "",
//       placeOfBirth: "",
//       stcwReference: "",
//       stcwRegulation: "",
//       certificateTitle: "",
//       certificateDepartment: "",
//       certificateGroup: "",
//       issueDate: "",
//       certificateExpiryDate: "",
//       issueCertDatePerformed: "",
//       interimExpiryDate: "",
//       stcwIssuePlace: "",
//       stcwPlaceOfExam: "",
//       placeOfExam: "",
//       trainingInstitution: "",
//       countryOfIssue: "",
//       issuingAuthority: "",
//       stcwCapacityOne: "",
//       stcwCapacityTwo: "",
//       stcwCapacityThree: "",
//       stcwCapacityFour: "",
//       stcwCapacityLimitationOn: "",
//       stcwCapacityLimitationTw: "",
//       stcwCapacityLimitationTh: "",
//       stcwCapacityLimitationFo: "",
//       stcwFunctionOne: "",
//       stcwFunctionTwo: "",
//       stcwFunctionThree: "",
//       stcwFunctionFour: "",
//       stcwFunctionFive: "",
//       stcwFunctionSix: "",
//       stcwLevelOne: "",
//       stcwLevelTwo: "",
//       stcwLevelThree: "",
//       stcwLevelFour: "",
//       stcwLevelFive: "",
//       stcwLevelSix: "",
//       stcwFunctionLimitationOn: "",
//       stcwFunctionLimitationTw: "",
//       stcwFunctionLimitationTh: "",
//       stcwFunctionLimitationFo: "",
//       stcwFunctionLimitationFi: "",
//       stcwFunctionLimitationSi: "",
//       additionalEndorse1: "",
//       additionalEndorse2: "",
//       additionalEndorse3: "",
//       additionalEndorse4: "",
//       additionalEndorse5: "",
//       additionalEndorse6: "",
//       copValidUntilOne: "",
//       copValidUntilTwo: "",
//       copValidUntilThree: "",
//       copValidUntilFour: "",
//       copValidUntilFive: "",
//       copValidUntilSix: "",
//       copValidUntilSeven: "",
//       copValidUntilEight: "",
//       copValidUntilNine: "",
//       copValidUntilTen: "",
//       copValidUntilEleven: "",
//       copValidUntilTwelve: "",
//       retainOldCertificateNumber: "",
//       countryOfIssueRegI10: "",
//       notRobot: false
//     });
//     setResults([]);
//     setStatusMessage('');
//     setButtonText('Verify');
//   };

//   const handleVerifyButton = () => {
//     if (buttonText === 'Verify') setButtonText('Submit');

//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setStatusMessage('');
//     setResults([]);
//     setIsSubmitting(true);

//     const idFilled = (formData.idNumber || '').trim() !== '';
//     const certFilled = (formData.certificateNumber || '').trim() !== '';

//     // Validation check
//     if (!idFilled && !certFilled) {
//       setStatusMessage('Please enter either an ID Number OR a Certificate Number.');
//       setIsSubmitting(false);
//       return;
//     }

//     // Build request body dynamically
//     const requestBody = {};
//     if (idFilled) requestBody.IdNumber = formData.idNumber;
//     if (certFilled) requestBody.CertificateNumber = formData.certificateNumber;

//     try {
//       const response = await fetch(`${WebApiURL}Verification/verify`, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(requestBody)
//       });

//       const text = await response.text();
//       let data;

//       try {
//         data = JSON.parse(text);
//       } catch {
//         setStatusMessage("Server returned invalid response format.");
//         return;
//       }

//       if (response.ok && data.matchedRecords?.length > 0) {
//         setResults(data.matchedRecords);
//         setStatusMessage('Verification successful.');

//         // Auto clear after 10 seconds
//         setTimeout(() => setStatusMessage(''), 10000);
//       } else {
//         setStatusMessage(data.message || 'No matching records found.');
//         setTimeout(() => setStatusMessage(''), 10000);
//       }
//     } catch (err) {
//       setStatusMessage('Server error or network issue.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };



//   // ---------- helpers to clean & map data to the template ----------
//   const clean = (v) => {
//     const s = (v ?? '').toString();
//     return s.trim();
//   };

//   const isPresent = (v) => clean(v) !== '';

//   const mapToCertificateView = (recInput) => {
//     // Utility functions
//     const clean = (v) => (v ?? '').toString().trim();
//     const isPresent = (v) => clean(v) !== '';

//     // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
//     const capacityDetailsRaw = [
//       { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
//       { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
//       { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
//       { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
//     ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

//     const functionsTopRaw = [
//       { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
//       { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
//       { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
//       { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const functionsBottomRaw = [
//       { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
//       { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
//     ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

//     const endorsements = [
//       recInput.additionalEndorse1,
//       recInput.additionalEndorse2,
//       recInput.additionalEndorse3,
//       recInput.additionalEndorse4,
//       recInput.additionalEndorse5,
//       recInput.additionalEndorse6,
//     ].map(clean).filter(isPresent);

//     return {
//       salutationName: 'Recipient',

//       firstName: clean(recInput.givenName) || '—',
//       surname: clean(recInput.surname) || '—',
//       dob: clean(recInput.dateOfBirth) || '—',
//       certificateNumber: clean(recInput.certificateNumber) || '—',
//       stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
//       issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
//       expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
//       certificateTitle: clean(recInput.certificateTitle) || '—',
//       // Optional arrays
//       capacityDetails: capacityDetailsRaw,
//       functionsTop: functionsTopRaw,
//       functionsBottom: functionsBottomRaw,
//       endorsements,
//     };
//   };

//   const openDetails = (rec) => {
//     const mapped = mapToCertificateView(rec);
//     setDetails(mapped);
//   };

//   const closeDetails = () => setDetails(null);

//   // ---------- UI ----------
//   return (
//     <div ref={certRef} id="cert-overlay" className="cert-page">
//       {/* <button
//         type="button"
//         className="text-decoration-none text-primary-green font-17 font-600 bg-white border-0"
//         onClick={() => setActiveForm("login")}
//       >
//         Log Out
//       </button> */}
//       <div className="form-group d-flex justify-content-between mt-3">
//         <button
//           type="button"
//           className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//         // onClick={() => setActiveForm("login")}
//         >

//         </button>
//         <button
//           type="button"
//           className="btn btn-primary-green height-40 max-120 px-5 text-white fw-normal rounded-1"

//           //className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//           //  onClick={() => setActiveForm("login")}
//           onClick={() => window.location.reload()}
//         >
//           Log Out
//         </button>
//       </div>
//       <div className="max-716 w-100 rounded-1 border p-4">
//         <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
//           Please capture the seafarer details you want to verify
//         </div>

//         {statusMessage && (
//           <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
//             {statusMessage}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className="row g-3">
//           {/* Surname */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="surname"
//                   value={formData.surname}
//                   onChange={handleInputChange}
//                 // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Given Names */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control ..."
//                   name="givenName"
//                   value={formData.givenName}
//                   onChange={handleInputChange}
//                 // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* ID/Passport */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="idNumber"
//                   value={formData.idNumber}
//                   onChange={handleInputChange}
//                 // removed required to allow either-or
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Certificate Number */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="certificateNumber"
//                   value={formData.certificateNumber}
//                   onChange={handleInputChange}
//                 // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Organization Type */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
//               </div>
//               <div className="col-md-8">
//                 <input
//                   type="text"
//                   className="form-control height-40 rounded-1 border-color-7D9199"
//                   name="organizationType"
//                   // value={formData.organizationType}
//                   onChange={handleInputChange}
//                 // required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="col-12">
//             <div className="row align-items-center">
//               <div className="col-md-4"></div>
//               <div className="col-md-8">
//                 <div className="row">
//                   <div className="col-auto">
//                     <button
//                       type="submit"
//                       className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
//                       onClick={handleVerifyButton}
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? 'Verifying...' : buttonText}
//                     </button>
//                   </div>
//                   <div className="col-auto">
//                     <button
//                       type="button"
//                       className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
//                       onClick={handleClear}
//                     >
//                       Clear
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Display Results */}
//           {results.length > 0 && (
//             <table className="table table-bordered mt-4">
//               <thead>
//                 <tr>
//                   <th>Num</th>
//                   <th>Surname</th>
//                   <th>Given Name</th>
//                   <th>Certificate Number</th>
//                   <th>Certificate Title</th>
//                   <th>Date Issued</th>
//                   <th>View</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {results.map((rec, index) => (
//                   <tr key={index}>
//                     <td>{index + 1}</td>
//                     <td>{rec.surname || '-'}</td>
//                     <td>{rec.givenName || ''} {rec.MiddleName || ''}</td>
//                     <td>{rec.certificateNumber}</td>
//                     <td>{rec.certificateTitle}</td>
//                     <td>{rec.issueDate || '-'}</td>
//                     <td>
//                       <a
//                         href="#"
//                         onClick={(e) => { e.preventDefault(); openDetails(rec); }}
//                       >
//                         View Details
//                       </a>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </form>

//         {/* ----- Certificate Modal (React version of your HTML) ----- */}
//         {details && (
//           <div
//             role="dialog"
//             aria-modal="true"
//             onClick={closeDetails}
//             style={{
//               position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
//               display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
//             }}
//           >
//             {/* stop click bubbling to close */}
//             <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
//               <style>{`
//                 :root {
//                   --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
//                 }
//                 .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
//                   box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
//                 .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
//                 .cert-header p { margin:0; color:var(--muted); }
//                 .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
//                 .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
//                 .kv .key { color: var(--muted); }
//                 .divider { height:1px; background:var(--border); margin:16px 0 8px; }
//                 h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
//                 table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
//                 th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
//                 th { background:#f9fafb; font-weight:600; }
//                 .muted { color: var(--muted); }
//                 .actions { display:flex; gap:10px; margin-top:18px; }
//                 .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
//                 .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
//                 .back-link { cursor:default; }
//                 @media print {
//                   body { background:#fff; }
//                   #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
//                   .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
//                   .actions, .back-link { display:none !important; }
//                   a { color:inherit; text-decoration:none; }
//                 }
//               `}</style>

//               <div id="cert-overlay" className="cert-page">
//                 <header className="cert-header">
//                   <div className="muted">Dear <span>{details.salutationName}</span></div>
//                   <h1>
//                     Thank you for enquiring on the validity of the certificate for{' '}
//                     <span>{details.fullName}</span>
//                   </h1>
//                 </header>

//                 <section aria-labelledby="personal-details">
//                   <div className="grid-2">
//                     <div className="kv">
//                       <div className="key">Seafarer's Name</div>
//                       <div>{details.firstName || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Seafarer's Surname</div>
//                       <div>{details.surname || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date of birth</div>
//                       <div>{details.dob || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Certificate Number</div>
//                       <div>{details.certificateNumber || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">STCW Reference</div>
//                       <div>{details.stcwReference || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Issue/Revalidation Date</div>
//                       <div>{details.issueDate || '—'}</div>
//                     </div>
//                     <div className="kv">
//                       <div className="key">Date Of Expiry</div>
//                       <div>{details.expiryDate || '—'}</div>
//                     </div>

//                   </div>
//                 </section>

//                 <div className="divider" />

//                 <section aria-labelledby="capacity-details">
//                   <h2 id="capacity-details">Capacity Details</h2>
//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Capacity</th>
//                         <th>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.capacity || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>

//                   <table>
//                     <thead>
//                       <tr>
//                         <th style={{ width: 64 }}>#</th>
//                         <th>Function</th>
//                         <th style={{ width: 180 }}>Level</th>
//                         <th style={{ width: 220 }}>Limitation</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
//                         <tr key={i}>
//                           <td>{i + 1}</td>
//                           <td>{row.func || '—'}</td>
//                           <td>{row.level || '—'}</td>
//                           <td>{row.limitation || '—'}</td>
//                         </tr>
//                       )) : null}
//                     </tbody>
//                   </table>
//                 </section>

//                 <section aria-labelledby="endorsements">
//                   <h2 id="endorsements">Additional Endorsement(s)</h2>
//                   <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
//                     {details.endorsements?.length ? details.endorsements.map((e, i) => (
//                       <li key={i}>{e}</li>
//                     )) : null}
//                   </ul>
//                 </section>

//                 <div className="actions">
//                   <button className="btn-primary-green " onClick={handleGeneratePDF}>Generate PDF</button>
//                   <button className="btnx" onClick={closeDetails}>Back</button>
//                 </div>

//                 <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
//                   <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
//                 </footer>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default VerifyForm;

import React, { useState } from 'react';
import { WebApiURL } from '../Constants/Constants';

import { useRef } from "react";

function VerifyForm({ setActiveForm }) {
  // ---------- your existing state ----------
  const [formData, setFormData] = useState({
    certificateNumber: "",
    idNumber: "",
    passportNumber: "",
    caseStatus: "",
    certificateType: "",
    expiryDate: "",
    givenName: "",
    middleName: "",
    surname: "",
    DateOfBirth: "",
    nationality: "",
    placeOfBirth: "",
    stcwReference: "",
    stcwRegulation: "",
    certificateTitle: "",
    certificateDepartment: "",
    certificateGroup: "",
    issueDate: "",
    certificateExpiryDate: "",
    issueCertDatePerformed: "",
    interimExpiryDate: "",
    stcwIssuePlace: "",
    stcwPlaceOfExam: "",
    placeOfExam: "",
    trainingInstitution: "",
    countryOfIssue: "",
    issuingAuthority: "",
    stcwCapacityOne: "",

    stcwCapacityTwo: "",
    stcwCapacityThree: "",
    stcwCapacityFour: "",
    stcwCapacityLimitationOn: "",
    stcwCapacityLimitationTw: "",
    stcwCapacityLimitationTh: "",
    stcwCapacityLimitationFo: "",
    stcwFunctionOne: "",
    stcwFunctionTwo: "",
    stcwFunctionThree: "",
    stcwFunctionFour: "",
    stcwFunctionFive: "",
    stcwFunctionSix: "",
    stcwLevelOne: "",
    stcwLevelTwo: "",
    stcwLevelThree: "",
    stcwLevelFour: "",
    stcwLevelFive: "",
    stcwLevelSix: "",
    stcwFunctionLimitationOn: "",
    stcwFunctionLimitationTw: "",
    stcwFunctionLimitationTh: "",
    stcwFunctionLimitationFo: "",
    stcwFunctionLimitationFi: "",
    stcwFunctionLimitationSi: "",
    additionalEndorse1: "",
    additionalEndorse2: "",
    additionalEndorse3: "",
    additionalEndorse4: "",
    additionalEndorse5: "",
    additionalEndorse6: "",
    copValidUntilOne: "",
    copValidUntilTwo: "",
    copValidUntilThree: "",
    copValidUntilFour: "",
    copValidUntilFive: "",
    copValidUntilSix: "",
    copValidUntilSeven: "",
    copValidUntilEight: "",
    copValidUntilNine: "",
    copValidUntilTen: "",
    copValidUntilEleven: "",
    copValidUntilTwelve: "",
    retainOldCertificateNumber: "",
    countryOfIssueRegI10: "",
    notRobot: false
  });

  const [buttonText, setButtonText] = useState('Verify');
  const [statusMessage, setStatusMessage] = useState('');
  const [results, setResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const certRef = useRef();
  // ---------- added: modal state ----------
  const [details, setDetails] = useState(null); // when set, modal opens


  //pdf generation 

  const handleGeneratePDF = async () => {
    if (!details) return;

    // Get logged-in user from localStorage
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    // ✅ Check for the actual property from OTP response
    if (!user?.userId) {
      alert("User not authenticated. Please verify OTP first.");
      return;
    }

    // ---------- DEBUG: log user object ----------
    console.log("User from localStorage:", user);
    console.log("UserId being sent to API:", user.userId);

    try {
      const response = await fetch(`${WebApiURL}Verification/generate-pdf`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          CertificateNumber: details.certificateNumber,
          IdNumber: details.idNumber,
          RObjectId: details.rObjectId,
          UserId: user.userId,
          FullName: user.fullName

        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to generate PDF');
      }

      const blob = await response.blob(); // PDF file as blob
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Verification_${details.certificateNumber || 'Report'}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert('Error generating PDF: ' + err.message);
    }
  };


  // ---------- your handlers (unchanged) ----------
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleClear = () => {
    setFormData({
      certificateNumber: "",
      idNumber: "",
      passportNumber: "",
      caseStatus: "",
      certificateType: "",
      expiryDate: "",
      givenName: "",
      middleName: "",
      surname: "",
      DateOfBirth: "",
      nationality: "",
      placeOfBirth: "",
      stcwReference: "",
      stcwRegulation: "",
      certificateTitle: "",
      certificateDepartment: "",
      certificateGroup: "",
      issueDate: "",
      certificateExpiryDate: "",
      issueCertDatePerformed: "",
      interimExpiryDate: "",
      stcwIssuePlace: "",
      stcwPlaceOfExam: "",
      placeOfExam: "",
      trainingInstitution: "",
      countryOfIssue: "",
      issuingAuthority: "",
      stcwCapacityOne: "",
      stcwCapacityTwo: "",
      stcwCapacityThree: "",
      stcwCapacityFour: "",
      stcwCapacityLimitationOn: "",
      stcwCapacityLimitationTw: "",
      stcwCapacityLimitationTh: "",
      stcwCapacityLimitationFo: "",
      stcwFunctionOne: "",
      stcwFunctionTwo: "",
      stcwFunctionThree: "",
      stcwFunctionFour: "",
      stcwFunctionFive: "",
      stcwFunctionSix: "",
      stcwLevelOne: "",
      stcwLevelTwo: "",
      stcwLevelThree: "",
      stcwLevelFour: "",
      stcwLevelFive: "",
      stcwLevelSix: "",
      stcwFunctionLimitationOn: "",
      stcwFunctionLimitationTw: "",
      stcwFunctionLimitationTh: "",
      stcwFunctionLimitationFo: "",
      stcwFunctionLimitationFi: "",
      stcwFunctionLimitationSi: "",
      additionalEndorse1: "",
      additionalEndorse2: "",
      additionalEndorse3: "",
      additionalEndorse4: "",
      additionalEndorse5: "",
      additionalEndorse6: "",
      copValidUntilOne: "",
      copValidUntilTwo: "",
      copValidUntilThree: "",
      copValidUntilFour: "",
      copValidUntilFive: "",
      copValidUntilSix: "",
      copValidUntilSeven: "",
      copValidUntilEight: "",
      copValidUntilNine: "",
      copValidUntilTen: "",
      copValidUntilEleven: "",
      copValidUntilTwelve: "",
      retainOldCertificateNumber: "",
      countryOfIssueRegI10: "",
      notRobot: false
    });
    setResults([]);
    setStatusMessage('');
    setButtonText('Verify');
  };

  const handleVerifyButton = () => {
    if (buttonText === 'Verify') setButtonText('Submit');

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatusMessage('');
    setResults([]);
    setIsSubmitting(true);

    const idFilled = (formData.idNumber || '').trim() !== '';
    const certFilled = (formData.certificateNumber || '').trim() !== '';

    // Validation check
    if (!idFilled && !certFilled) {
      setStatusMessage('Please enter either an ID Number OR a Certificate Number.');
      setIsSubmitting(false);
      return;
    }

    // Build request body dynamically
    const requestBody = {};
    if (idFilled) requestBody.IdNumber = formData.idNumber;
    if (certFilled) requestBody.CertificateNumber = formData.certificateNumber;

    try {
      const response = await fetch(`${WebApiURL}Verification/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      });

      const text = await response.text();
      let data;

      try {
        data = JSON.parse(text);
      } catch {
        setStatusMessage("Server returned invalid response format.");
        return;
      }

      if (response.ok && data.matchedRecords?.length > 0) {
        setResults(data.matchedRecords);
        setStatusMessage('Verification successful.');
        console.log("Matched Records:", data.matchedRecords);

        // Auto clear after 10 seconds
        setTimeout(() => setStatusMessage(''), 10000);
      } else {
        setStatusMessage(data.message || 'No matching records found.');
        setTimeout(() => setStatusMessage(''), 10000);
      }
    } catch (err) {
      setStatusMessage('Server error or network issue.');
    } finally {
      setIsSubmitting(false);
    }
  };



  // ---------- helpers to clean & map data to the template ----------
  const clean = (v) => {
    const s = (v ?? '').toString();
    return s.trim();
  };

  const isPresent = (v) => clean(v) !== '';

  const mapToCertificateView = (recInput) => {
    // Utility functions
    const clean = (v) => (v ?? '').toString().trim();
    const isPresent = (v) => clean(v) !== '';

    // Capacity, function, and endorsement details if you need them for the modal (use from API record, not formData!)
    const capacityDetailsRaw = [
      { capacity: clean(recInput.stcwCapacityOne), limitation: clean(recInput.stcwCapacityLimitationOn) },
      { capacity: clean(recInput.stcwCapacityTwo), limitation: clean(recInput.stcwCapacityLimitationTw) },
      { capacity: clean(recInput.stcwCapacityThree), limitation: clean(recInput.stcwCapacityLimitationTh) },
      { capacity: clean(recInput.stcwCapacityFour), limitation: clean(recInput.stcwCapacityLimitationFo) },
    ].filter(row => isPresent(row.capacity) || isPresent(row.limitation));

    const functionsTopRaw = [
      { func: clean(recInput.stcwFunctionOne), level: clean(recInput.stcwLevelOne), limitation: clean(recInput.stcwFunctionLimitationOn) },
      { func: clean(recInput.stcwFunctionTwo), level: clean(recInput.stcwLevelTwo), limitation: clean(recInput.stcwFunctionLimitationTw) },
      { func: clean(recInput.stcwFunctionThree), level: clean(recInput.stcwLevelThree), limitation: clean(recInput.stcwFunctionLimitationTh) },
      { func: clean(recInput.stcwFunctionFour), level: clean(recInput.stcwLevelFour), limitation: clean(recInput.stcwFunctionLimitationFo) },
    ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

    const functionsBottomRaw = [
      { func: clean(recInput.stcwFunctionFive), level: clean(recInput.stcwLevelFive), limitation: clean(recInput.stcwFunctionLimitationFi) },
      { func: clean(recInput.stcwFunctionSix), level: clean(recInput.stcwLevelSix), limitation: clean(recInput.stcwFunctionLimitationSi) },
    ].filter(r => isPresent(r.func) || isPresent(r.level) || isPresent(r.limitation));

    const endorsements = [
      recInput.additionalEndorse1,
      recInput.additionalEndorse2,
      recInput.additionalEndorse3,
      recInput.additionalEndorse4,
      recInput.additionalEndorse5,
      recInput.additionalEndorse6,
    ].map(clean).filter(isPresent);

    return {
      salutationName: 'Recipient',

      firstName: clean(recInput.givenName) || '—',
      surname: clean(recInput.surname) || '—',
      dob: clean(recInput.dateOfBirth) || '—',
      certificateNumber: clean(recInput.certificateNumber) || '—',
      stcwReference: clean(recInput.stcwReference) || clean(recInput.stcwRegulation) || '—',
      issueDate: clean(recInput.issueDate) || clean(recInput.issueCertDatePerformed) || '—',
      expiryDate: clean(recInput.certificateExpiryDate) || clean(recInput.expiryDate) || '—',
      certificateTitle: clean(recInput.certificateTitle) || '—',
      // Optional arrays
      capacityDetails: capacityDetailsRaw,
      functionsTop: functionsTopRaw,
      functionsBottom: functionsBottomRaw,
      endorsements,
    };
  };

  const openDetails = (rec) => {
    const mapped = mapToCertificateView(rec);
    mapped.rObjectId = rec.RObjectId || rec.rObjectId;
    setDetails(mapped);
  };


  const closeDetails = () => setDetails(null);

  // ---------- UI ----------
  return (
    <div ref={certRef} id="cert-overlay" className="cert-page">
      <div className="form-group d-flex justify-content-between mt-3">
        <button
          type="button"
          className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
        // onClick={() => setActiveForm("login")}
        >

        </button>
        <button
          type="button"
          className="btn btn-primary-green height-40 max-120 px-5 text-white fw-normal rounded-1"

          //className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
          //  onClick={() => setActiveForm("login")}
          onClick={() => window.location.reload()}
        >
          Log Out
        </button>
      </div>
      <div className="max-716 w-100 rounded-1 border p-4">
        <div className="font-24 font-700 mb-4 text-center text-primary-green border-bottom pb-2">
          Please capture the seafarer details you want to verify
        </div>

        {statusMessage && (
          <div className={`alert ${results.length ? 'alert-success' : 'alert-danger'}`}>
            {statusMessage}
          </div>
        )}

        <form onSubmit={handleSubmit} className="row g-3">
          {/* Surname */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">Surname</label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control ..."
                  name="surname"
                  value={formData.surname}
                  onChange={handleInputChange}
                // required
                />
              </div>
            </div>
          </div>

          {/* Given Names */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">Given Names</label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control ..."
                  name="givenName"
                  value={formData.givenName}
                  onChange={handleInputChange}
                // required
                />
              </div>
            </div>
          </div>

          {/* ID/Passport */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">ID or Passport</label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control height-40 rounded-1 border-color-7D9199"
                  name="idNumber"
                  value={formData.idNumber}
                  onChange={handleInputChange}
                // removed required to allow either-or
                />
              </div>
            </div>
          </div>

          {/* Certificate Number */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">Certificate Number</label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control height-40 rounded-1 border-color-7D9199"
                  name="certificateNumber"
                  value={formData.certificateNumber}
                  onChange={handleInputChange}
                // required
                />
              </div>
            </div>
          </div>

          {/* Organization Type */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4">
                <label className="form-label font-17 font-400 text-primary-green mb-0">Organization Type</label>
              </div>
              <div className="col-md-8">
                <input
                  type="text"
                  className="form-control height-40 rounded-1 border-color-7D9199"
                  name="organizationType"
                  // value={formData.organizationType}
                  onChange={handleInputChange}
                // required
                />
              </div>
            </div>
          </div>

          {/* Buttons */}
          <div className="col-12">
            <div className="row align-items-center">
              <div className="col-md-4"></div>
              <div className="col-md-8">
                <div className="row">
                  <div className="col-auto">
                    <button
                      type="submit"
                      className="btn btn-primary-green height-50 max-165 px-5 text-white w-100 fw-normal rounded-1"
                      onClick={handleVerifyButton}
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? 'Verifying...' : buttonText}
                    </button>
                  </div>
                  <div className="col-auto">
                    <button
                      type="button"
                      className="btn btn-outline-primary-green height-50 max-165 px-5 w-100 fw-normal rounded-1"
                      onClick={handleClear}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display Results */}
          {results.length > 0 && (
            <table className="table table-bordered mt-4">
              <thead>
                <tr>
                  <th>Num</th>
                  <th>Surname</th>
                  <th>Given Name</th>
                  <th>Certificate Number</th>
                  <th>Certificate Title</th>
                  <th>Date Issued</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {results.map((rec, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{rec.surname || '-'}</td>
                    <td>{rec.givenName || ''} {rec.MiddleName || ''}</td>
                    <td>{rec.certificateNumber}</td>
                    <td>{rec.certificateTitle}</td>
                    <td>{rec.issueDate || '-'}</td>
                    <td>
                      <a
                        href="#"
                        onClick={(e) => { e.preventDefault(); openDetails(rec); }}
                      >
                        View Details
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </form>

        {/* ----- Certificate Modal (React version of your HTML) ----- */}
        {details && (
          <div
            role="dialog"
            aria-modal="true"
            onClick={closeDetails}
            style={{
              position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
              display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 12
            }}
          >
            {/* stop click bubbling to close */}
            <div onClick={(e) => e.stopPropagation()} style={{ width: '100%', maxWidth: 980 }}>
              <style>{`
                :root {
                  --text: #111827; --muted: #4b5563; --border: #e5e7eb; --primary: #1f2937; --accent: #2563eb;
                }
                .cert-page { background:#fff; border:1px solid var(--border); border-radius:14px; padding:24px;
                  box-shadow:0 2px 10px rgba(0,0,0,.04); max-height:90vh; overflow:auto; }
                .cert-header h1 { font-size:20px; margin:0 0 4px; font-weight:600; }
                .cert-header p { margin:0; color:var(--muted); }
                .grid-2 { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px 24px; margin-top:18px; }
                .kv { display:grid; grid-template-columns:180px 1fr; gap:8px; align-items:center; }
                .kv .key { color: var(--muted); }
                .divider { height:1px; background:var(--border); margin:16px 0 8px; }
                h2 { font-size:18px; margin:20px 0 8px; color:var(--primary); }
                table { width:100%; border-collapse:collapse; margin:8px 0 16px; }
                th, td { border:1px solid var(--border); padding:10px 12px; text-align:left; vertical-align:top; }
                th { background:#f9fafb; font-weight:600; }
                .muted { color: var(--muted); }
                .actions { display:flex; gap:10px; margin-top:18px; }
                .btnx { border:1px solid var(--border); padding:10px 14px; border-radius:10px; cursor:pointer; background:#f8fafc; }
                .btnx.primary { background:var(--accent); color:#fff; border-color:var(--accent); }
                .back-link { cursor:default; }
                @media print {
                  body { background:#fff; }
                  #cert-overlay { position:static !important; background:transparent !important; padding:0 !important; }
                  .cert-page { border:none; box-shadow:none; max-height:none; overflow:visible; }
                  .actions, .back-link { display:none !important; }
                  a { color:inherit; text-decoration:none; }
                }
              `}</style>

              <div id="cert-overlay" className="cert-page">
                <header className="cert-header">
                  <div className="muted">Dear <span>{details.salutationName}</span></div>
                  <h1>
                    Thank you for enquiring on the validity of the certificate for{' '}
                    <span>{details.fullName}</span>
                  </h1>
                </header>

                <section aria-labelledby="personal-details">
                  <div className="grid-2">
                    <div className="kv">
                      <div className="key">Seafarer's Name</div>
                      <div>{details.firstName || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">Seafarer's Surname</div>
                      <div>{details.surname || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">Date of birth</div>
                      <div>{details.dob || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">Certificate Number</div>
                      <div>{details.certificateNumber || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">STCW Reference</div>
                      <div>{details.stcwReference || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">Issue/Revalidation Date</div>
                      <div>{details.issueDate || '—'}</div>
                    </div>
                    <div className="kv">
                      <div className="key">Date Of Expiry</div>
                      <div>{details.expiryDate || '—'}</div>
                    </div>

                  </div>
                </section>

                <div className="divider" />

                <section aria-labelledby="capacity-details">
                  <h2 id="capacity-details">Capacity Details</h2>
                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: 64 }}>#</th>
                        <th>Capacity</th>
                        <th>Limitation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details.capacityDetails?.length ? details.capacityDetails.map((row, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{row.capacity || '—'}</td>
                          <td>{row.limitation || '—'}</td>
                        </tr>
                      )) : null}
                    </tbody>
                  </table>

                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: 64 }}>#</th>
                        <th>Function</th>
                        <th style={{ width: 180 }}>Level</th>
                        <th style={{ width: 220 }}>Limitation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details.functionsTop?.length ? details.functionsTop.map((row, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{row.func || '—'}</td>
                          <td>{row.level || '—'}</td>
                          <td>{row.limitation || '—'}</td>
                        </tr>
                      )) : null}
                    </tbody>
                  </table>

                  <table>
                    <thead>
                      <tr>
                        <th style={{ width: 64 }}>#</th>
                        <th>Function</th>
                        <th style={{ width: 180 }}>Level</th>
                        <th style={{ width: 220 }}>Limitation</th>
                      </tr>
                    </thead>
                    <tbody>
                      {details.functionsBottom?.length ? details.functionsBottom.map((row, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td>
                          <td>{row.func || '—'}</td>
                          <td>{row.level || '—'}</td>
                          <td>{row.limitation || '—'}</td>
                        </tr>
                      )) : null}
                    </tbody>
                  </table>
                </section>

                <section aria-labelledby="endorsements">
                  <h2 id="endorsements">Additional Endorsement(s)</h2>
                  <ul style={{ margin: '8px 0 0 18px', padding: 0 }}>
                    {details.endorsements?.length ? details.endorsements.map((e, i) => (
                      <li key={i}>{e}</li>
                    )) : null}
                  </ul>
                </section>

                <div className="actions">
                  <button className="btn-primary-green " onClick={handleGeneratePDF}>Generate PDF</button>
                  <button className="btnx" onClick={closeDetails}>Back</button>
                </div>

                <footer style={{ marginTop: 28, color: 'var(--muted)', fontSize: 12 }}>
                  <div>© {new Date().getFullYear()} – Verification System · <span className="back-link">Privacy</span></div>
                </footer>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default VerifyForm;
